import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import {getUserInfo} from "../restful/api";
Vue.use(Vuex);
let store = new Vuex.Store({
	state:{
		 schoolInfo:{},//存储是为了防止数据丢失
		 userInfo:{},//存储是为了防止数据丢失
		 count:1,
	},
	// 修改state的唯一方法 是提交mutations
	mutations:{
		SetSchoolInfo(state,school){

			state.schoolInfo = school;
		},
		SetUserInfo(state,user){

			state.userInfo = user;
		},
		addcount(state){

			state.count = state.count+1;
			console.log(state.count)
		},
	},
  getters: {
    //get方法
    getUserInfo: state => state.userInfo,
    getSchoolInfo: state => state.schoolInfo

  },
	actions:{
    SetSchoolInfo({commit},school){

			commit('SetSchoolInfo',school);
		},
    SetUserInfo({commit},user){

			commit('SetUserInfo',user);
		},
		addcount({commit}){
				commit('addcount');
			},
	}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js